<template>
  <div>
    <basic-container>
      <!--下拉列表-->
      <!--<template >-->
      <!--<el-select v-model="value" placeholder="请选择"  @change="statusChange">-->
      <!--<el-option-->
      <!--v-for="item in statusData"-->
      <!--:key="item.value"-->
      <!--:label="item.label"-->
      <!--:value="item.value">-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</template>-->
      <div id="charts">
        <div
          id="pieChart"
          style="width: 500px;height:400px;"
        ></div>
        <div
          id="lineChart"
          style="width: 600px;height:400px;"
        ></div>
      </div>
      <div class="charts as">
        <div
          class="block"
          style="margin-left:80px"
        >
          <el-date-picker
            v-model="chooseDate1"
            type="month"
            size="small"
            @change="chooseDateStart"
            placeholder="选择查询起始月"
          ></el-date-picker>
        </div>
        <div style="lineHeight:30px">至</div>
        <div class="block">
          <el-date-picker
            v-model="chooseDate2"
            size="small"
            type="month"
            @change="chooseDateEnd"
            placeholder="选择查询结束月"
          ></el-date-picker>
        </div>
        <el-button
          size="small"
          style="height:32px;margin-left: 10px;"
          @click="chooseClick"
        >查询</el-button>
        <el-button
          size="small"
          style="height:32px;margin-left: 5px;"
          @click="chooseClear"
        >清空</el-button>
      </div>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @row-save="handleSave"
        @search-reset="searchClear"
        @row-update="handleUpdate"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <!-- <template slot="searchMenu">
          <el-button
            size="small"
            class="el-icon-delete"
            @click="searchClear"
            style="width: 80px;left: -88px;position: relative;"
          >清空</el-button>
        </template>-->
        <template slot="search"></template>
        <template
          slot-scope="scope"
          slot="menuLeft"
        >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            plain
            @click.stop="downloadexportFinanceDetail"
          >下载Excel</el-button>
          <el-button
            type="primary"
            icon="el-icon-printer"
            size="small"
            plain
            @click.stop="printJson()"
          >打印</el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script src="https://cdnjs.cloudflare.com/ajax/libs/echarts/4.3.0/echarts.js"></script>
<script>
import { mapGetters } from "vuex";
import { financialOption } from "@/const/salesCloud/financialOption";
import { financialPieOption } from "@/const/salesCloud/financialPieOption";
import {
  statusSearch,
  findCategoryAll,
  updateWorkOrderMerchants,
  evaluation,
  immediatePay,
  findItemsByCategory,
  findUsersByUserTypeAll,
  findUsersByUserType,
  insertWorkOrderMerchants,
  userPass,
  userRefused,
  cancelWorkOrder,
} from "@/api/salesCloud/workOrder";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import {
  findFinancialList,
  findFinancialListDownloadExcel,
  addPledge,
  findLineData,
  findTotalMoney,
  findFinancialListGet,
} from "@/api/salesCloud/financial";
import { excelaxios } from "@/util/excelaxios";
import { findUserInfo } from "@/api/basic/user";
import { DIC } from "@/const/dic";
import VueQr from "vue-qr";
import { log } from "util";
import { exportExcel } from "xlsx-oc";
import { getCompany } from "@/util/auth";
import { formatterTime, formatterDateToUTC, parseStatus } from "@/util/util";
export default {
  name: "financial",
  components: {
    VueQr,
  },
  data() {
    return {
      pieOption: financialPieOption,
      tableOption: financialOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      eleDialog: false,
      serviceCategoryId: "",
      serviceItemId: "",
      payTime: {},
      theme: "",
      lineData: [],
      totalMoney: {},
      tabelObj: {},
      lineSearchData: {},
      chooseDate1: "",
      chooseDate2: "",
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10, //每页显示多少条
      },
      grade: {
        box: false,
        check: [],
      },
      users: [],
      userType: "JOINS_ENGINEER",
      point: {},
      serviceCategorys: [],
      serviceCategory: {},
      joinsWorkServiceItems: [],
      workOrderStatus: DIC.WORK_ORDER_STATUS,
      QRCodeDialog: false,
      config: {},
      evaluateDialog: false,
      score: 5,
      clues: [],
      evaluateObj: {},
      serviceItem: {},
      workerUser: {},
      workOrderData: {},
      stockSuperviseDialog: false,
      serviceFee: [],
      propertiesViceList: [],
      value: "",
      downloadData: {},
    };
  },
  created() {
    this.handleList();
  },
  watch: {
    lineSearchData: function () {
      console.log("watch", this.lineSearchData);
      this.lineSearchData = this.lineSearchData;
    },
  },
  mounted() {
    // this.echartsInit();
    findTotalMoney().then((res) => {
      console.log(res);
      let data = JSON.parse(res.data);
      let totalMoney = {
        earningMoney: data.earningMoney,
        expendMoney: data.expendMoney,
        profitMoney: data.profitMoney,
      };
      console.log(this.lineSearchData);
      console.log("lineSearchData", this.lineSearchData);
      let profitMoney = this.profitMoney;
      console.log("this.data", totalMoney);
      // 基于准备好的dom，初始化echarts实例
      var pieChart = echarts.init(document.getElementById("pieChart"));
      // 指定图表的配置项和数据
      var option = {
        title: {
          text: "本月经营利润总计:" + totalMoney.profitMoney + "元",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} ({d}%)",
        },
        legend: {
          orient: "",
          top: "middle",
          bottom: 10,
          left: "right",
          data: [
            "收入总计:" + totalMoney.earningMoney + "元",
            "支出总计:" + totalMoney.expendMoney + "元",
          ],
        },
        series: [
          {
            name: "数据来源",
            type: "pie",
            radius: "50%",
            center: ["30%", "50%"],
            selectedMode: "single",
            data: [
              {
                value: totalMoney.earningMoney,
                name: "收入总计:" + totalMoney.earningMoney + "元",
              },
              {
                value: totalMoney.expendMoney,
                name: "支出总计:" + totalMoney.expendMoney + "元",
              },
            ],
            label: {
              normal: {
                textStyle: {
                  color: "rgba(255, 255, 255, 0)",
                },
              },
            },
            labelLine: {
              normal: {
                lineStyle: {
                  color: "rgba(255, 255, 255, 0)",
                },
                smooth: 0.2,
                length: 10,
                length2: 20,
              },
            },
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      pieChart.setOption(option);
    });
    this.lineCharthandle();
  },
  updated: function () {
    // let data = {
    //   startTime: this.startTime ? this.startTime.getTime() : "",
    //   endTime: this.endTime ? this.endTime.getTime() : ""
    // };
    // console.log(data);
  },
  computed: {
    ...mapGetters(["permission"]),
  },
  props: [],
  methods: {
    getLastDay(year, month) {
      var new_year = year; //取当前的年份
      var new_month = month++; //取下一个月的第一天，方便计算（最后一天不固定）
      if (month > 12) {
        new_month -= 12; //月份减
        new_year++; //年份增
      }
      var new_date = new Date(new_year, new_month, 1); //取当年当月中的第一天
      return new Date(new_date.getTime() - 1000 * 60 * 60 * 24).getDate(); //获取当月最后一天日期
    },
    lineCharthandle() {
      let endTime = new Date().setDate(
        this.getLastDay(new Date().getFullYear(), new Date().getMonth() + 1)
      );
      // let lastDay = this.getLastDay(
      //   new Date().getFullYear(),
      //   new Date().getMonth() + 1
      // );
      // console.log(lastDay);
      // console.log(endTime.setDate(lastDay));
      // let st = new Date().getMonth();
      // console.log(st);
      // endTime = endTime.setMonth(st + 1);
      // console.log(endTime);
      // endTime = endTime.getTime();
      console.log("280endtime", endTime);
      let startTime = new Date().setMonth(new Date().getMonth() - 5);
      console.log("278starttime", startTime);
      let data = {
        startTime,
        endTime,
      };
      let lineData = this.lineData;
      var lineChart = echarts.init(document.getElementById("lineChart"));
      this.lineChart = lineChart;
      console.log(this.lineData);
      console.log(new Date().getMonth());
      // new Date().getMonth() + -4 < 0
      //   ? new Date().getMonth() + -4 + 12
      //   : new Date().getMonth() + -4;

      findLineData(data).then((res) => {
        let lineTitle =
          (new Date().getMonth() + -4 < 0
            ? new Date().getFullYear() - 1
            : new Date().getFullYear()) +
          "年" +
          (new Date().getMonth() + -4 < 0
            ? new Date().getMonth() + -4 + 12
            : new Date().getMonth() + -4) +
          "月" +
          "-" +
          new Date().getFullYear() +
          "年" +
          (new Date().getMonth() + 1) +
          "月";
        console.log(startTime);
        let data = JSON.parse(res.data);
        let lineData = [];
        let lineYData = [];
        // for (let i in data) {
        //   console.log(data[i]);
        //   lineData.push(data[i]);
        //   lineYData.push(new Date().getMonth() + -4 + Number(i) + "月");
        //   console.log(lineYData);
        // }
        for (let i in data) {
          lineData.push(data[i]);
          lineYData.push(
            (new Date().getMonth() + -4 + Number(i) < 0
              ? new Date().getMonth() + -4 + Number(i) + 12
              : new Date().getMonth() + -4 + Number(i) == 0
              ? 12
              : new Date().getMonth() + -4 + Number(i)) + "月"
          );
          // lineYData.push(this.startTime.getMonth() + 1 + Number(i) + "月");
        }
        lineChart.setOption({
          title: {
            text: lineTitle,
            left: "center",
          },
          tooltip: {
            trigger: "axis",
          },
          xAxis: {
            type: "category",
            data: lineYData,
          },
          grid: {
            containLabel: true, //y轴数值显示完全
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: lineData,
              type: "line",
            },
          ],
        });
      });
    },
    chooseDateStart() {
      console.log(this.chooseDate1);
      this.startTime = this.chooseDate1;
      // findLineData(data).then(res => {
      //   console.log(res);
      // });
    },
    chooseDateEnd() {
      console.log(this.chooseDate2);
      console.log(this.chooseDate2.getTime());

      this.endTime = this.chooseDate2;

      // let nt = this.chooseDate2;
      // let sM = nt.getMonth();
      // nt.setMonth(sM + 1);
      // console.log(nt.getTime() - 1);
      // console.log(this.chooseDate2.getTime() - 1);
    },
    chooseClick() {
      console.log(this);
      // let data = {
      //   startTime: this.startTime ? this.startTime.getTime() : "",
      //   endTime: this.endTime
      //     ? this.endTime.setDate(
      //         this.getLastDay(
      //           this.endTime.getFullYear(),
      //           this.endTime.getMonth() + 1
      //         )
      //       )
      //     : ""
      // };
      let data = {
        startTime: this.startTime ? this.startTime.getTime() : "",
        endTime: this.endTime
          ? this.endTime.setDate(
              this.getLastDay(
                this.endTime.getFullYear(),
                this.endTime.getMonth() + 1
              )
            )
          : "",
      };
      console.log(data.endTime - data.startTime < 31536000000);
      data.endTime = data.endTime + 1000 * 60 * 60 * 24 - 1;
      console.log("结束时间", data.endTime);
      if (
        data.startTime != "" &&
        data.endTime != "" &&
        data.startTime < data.endTime &&
        data.startTime != data.endTime &&
        this.endTime.setDate(
          this.getLastDay(
            this.endTime.getFullYear(),
            this.endTime.getMonth() + 1
          )
        ) -
          this.startTime.getTime() <
          31536000000
      ) {
        console.log(this.lineSearchData);
        // data.endTime += 1000;
        console.log(data);
        findLineData(data).then((res) => {
          this.lineSearchData = {
            startTime: data.startTime,
            endTime: data.endTime,
            title:
              this.startTime.getFullYear() +
              "年" +
              (this.startTime.getMonth() + 1) +
              "月" +
              "-" +
              this.endTime.getFullYear() +
              "年" +
              (this.endTime.getMonth() + 1) +
              "月",
          };
          this.$nextTick(() => {
            let lineTitle = this.lineSearchData.title;
            let data = JSON.parse(res.data);
            let lineData = [];
            let lineYData = [];
            for (let i in data) {
              lineData.push(data[i]);
              if (this.startTime.getMonth() + 1 + Number(i) > 12) {
                lineYData.push(
                  this.startTime.getMonth() + 1 + Number(i) - 12 + "月"
                );
              } else {
                lineYData.push(
                  this.startTime.getMonth() + 1 + Number(i) + "月"
                );
              }
              // lineYData.push(this.startTime.getMonth() + 1 + Number(i) + "月");
            }
            this.lineChart.setOption({
              title: {
                text: lineTitle,
                left: "center",
              },
              xAxis: {
                type: "category",
                data: lineYData,
              },
              series: [
                {
                  data: lineData,
                  type: "line",
                },
              ],
            });
          });
        });
      } else if (data.startTime > data.endTime) {
        this.$message({
          showClose: true,
          message: "开始时间不能大于结束时间",
          type: "error",
        });
      } else if (data.startTime === "" || data.endTime === "") {
        this.$message({
          showClose: true,
          message: "查询时间不能为空",
          type: "error",
        });
      } else {
        this.$message({
          showClose: true,
          message: "最长支持查询一年以内",
          type: "error",
        });
      }
    },
    chooseClear() {
      this.chooseDate2 = "";
      this.chooseDate1 = "";
      this.startTime = "";
      this.endTime = "";
      // this.endTime = new Date();
      // this.startTime = new Date();
    },
    handleDialog(row, index) {
      this.stockSuperviseDialog = true;
      // this.evaluateDialog =true
      this.formobj = row;
      console.log(row, index);
    },
    statusChange() {
      //下拉框状态发生改变时
      //console.log(this.value);
      let params = this.value;
      statusSearch(params).then((res) => {
        let data = JSON.parse(res.data);
        console.log(data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      findFinancialList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize,
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      findFinancialList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize,
        };
        this.tableLoading = false;
      });
    },
    searchClear() {
      this.$refs.crud.$refs.searchForm.resetFields();
      this.serviceCategory = "";
      this.serviceCategoryId = "";
      this.serviceItem = "";
      this.serviceItemId = "";
      console.log(this);
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      } else {
        params.startTime = "";
        params.endTime = "";
      }
      // console.log(this.$refs.crud.resetForm)
      this.downloadData = params;
      console.log(params);
      console.log(this);
      findFinancialList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size,
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      console.log(page);
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.page.currentPage;
      params.size = page.page.pageSize;
      this.downloadData = params;
      findFinancialList(params).then((res) => {
        console.log(res);
        console.log(this.page);
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        console.log(data);
        this.page = {
          total: data.total,
          currentPage: page.page.currentPage,
          pageSize: page.page.pageSize,
        };
        this.tableLoading = false;
      });
    },

    handleDetail(row, index) {},
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.point = {};
      this.serviceCategory = {};
      this.joinsWorkServiceItems = [];
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      this.workerUser = {};
      this.serviceCategory.id = row.serviceCategoryId;
      this.choseWorkServiceItem();
      this.workerUser.id = row.workerUserId;
      let location = {};
      console.log("集合：" + JSON.stringify(row));
      location.lng = row.longitude;
      location.lat = row.latitude;
      this.point.location = location;
      this.point.pname = row.province;
      this.point.cityname = row.city;
      this.point.adname = row.area;
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize,
      };
      console.log(params);
      this.downloadData = params;
      findFinancialList(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize,
        };
        console.log(this.page);
        this.tableLoading = false;
      });
      console.log(this);
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.serviceCategoryId = this.serviceCategory.id;
      row.childList = this.childList;
      row.longitude = this.point.location.lng;
      row.latitude = this.point.location.lat;
      row.province = this.point.pname;
      row.city = this.point.cityname;
      row.area = this.point.adname;
      row.workerUserId = this.workerUser.id;
      row.serviceItemId = this.serviceItem;
      console.log("serviceItem：" + JSON.stringify(this.serviceItem));
      insertWorkOrderMerchants(row)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success",
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
      done();
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      row.serviceCategoryId = this.serviceCategory.id;
      row.childList = this.childList;
      row.longitude = this.point.location.lng;
      row.latitude = this.point.location.lat;
      row.province = this.point.pname;
      row.city = this.point.cityname;
      row.area = this.point.adname;
      row.workerUserId = this.workerUser.id;
      console.log("集合：" + JSON.stringify(row));
      updateWorkOrderMerchants(row)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success",
            });
            this.handleList();
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
      done();
    },
    userPass(row) {
      console.log(row);
      let obj = {};
      obj.id = row.id;
      userPass(obj).then((res) => {
        this.handleList();
      });
    },
    userRefused(row) {
      this.$prompt("请输入拒绝理由", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^.{1,255}$/,
        inputErrorMessage: "请输入正确长度的备注信息1-255",
      }).then(({ value }) => {
        let obj = {};
        obj.id = row.id;
        obj.reason = value;
        userRefused(obj).then((res) => {
          this.handleList();
        });
      });
    },
    immediatePayment(row) {
      this.config.value = "";
      let obj = {};
      obj.id = row.id;
      immediatePay(obj).then((response) => {
        this.tableLoading = false;
        if (response.code == "200") {
          let data = response.data;
          wxNativePayQuery(data.outTradeNo).then((res) => {
            console.log(res);
            if (res.code == "200") {
              if (res.data == "SUCCESS") {
                let _this = this;
                setTimeout(function () {
                  _this.QRCodeDialog = false;
                  _this.$message({
                    showClose: true,
                    message: "支付成功",
                    type: "success",
                  });
                  _this.handleList();
                }, 1000);
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付超时",
                  type: "error",
                });
              }
              //this.handleList();
            } else {
              this.QRCodeDialog = false;
              this.$message({
                showClose: true,
                message: "支付超时",
                type: "error",
              });
              this.handleList();
            }
          });
          let start = new Date().getTime();
          while (true) if (new Date().getTime() - start > 1) break;
          this.config.value = "";
          this.config.value = data.codeUrl;
          console.log("集合：" + this.config.value);
          this.QRCodeDialog = true;
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
          done();
          this.$refs.crud.rowAdd();
          return;
        }
        // let data = JSON.parse(res.data);
      });
    },
    showEvaluate(row) {
      this.evaluateObj.workOrderId = row.id;
      this.evaluateDialog = true;
    },
    rateChange() {
      //alert(this.evaluateObj.score);
    },
    evaluate() {
      // this.evaluateObj.workOrderId=row.id;
      console.log("集合：" + JSON.stringify(this.evaluateObj));
      // evaluation(this.serviceCategory.id).then((res) => {
      //     let data = JSON.parse(res.data)
      //     this.joinsWorkServiceItems = data
      // })

      evaluation(this.evaluateObj)
        .then((response) => {
          if (response.code == "200") {
            this.$message({
              showClose: true,
              message: "评价成功",
              type: "success",
            });
            this.handleList();
            this.evaluateDialog = false;
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error,
            type: "error",
          });
        });
    },
    formmaterImage(row) {
      let str = new Array();
      console.log("row：" + JSON.stringify(row));
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    },
    cancelWorkOrder(id) {
      this.$confirm(`是否确认取消?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          cancelWorkOrder(id)
            .then((response) => {
              if (response.code == "200") {
                this.$message({
                  showClose: true,
                  message: "取消成功",
                  type: "success",
                });
                this.handleList();
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    downloadexportFinanceDetail() {
      // let params = this.downloadData;
      // let url = `/joins-invoice-system/v1/finance/exportFinanceDetail?`;
      // excelaxios(url, params);
      let params = this.downloadData;
      delete params.page;
      params.size = this.page.total;
      findFinancialListDownloadExcel(params).then((res) => {
        window.open(res);
      });
    },
    printJson() {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      } else {
        params.startTime = "";
        params.endTime = "";
      }
      console.log(params);
      findFinancialList(params).then((res) => {
        let data = JSON.parse(res.data);
        console.log(data);
        let someJSONdata = data.rows;
        someJSONdata = someJSONdata.map((item) => {
          item.enterTime = formatterDateToUTC(item.enterTime);
          if (item.type == "EXPEND") {
            item.type = "支出";
          } else if (item.type == "INCOME") {
            item.type = "收入";
          } else {
            item.type = "error:" + item.type;
          }
          if (item.source == "RED_PACKET") {
            item.source = "红包";
          } else if (item.source == "POINTS_MALL") {
            item.source = "积分商城";
          } else if (item.source == "WORK_ORDER") {
            item.source = "工单";
          } else if (item.source == "WITHDRAW_DEPOSIT") {
            item.source = "提现";
          } else if (item.source == "WALLET_RECHARGE") {
            item.source = "余额充值";
          } else if (item.source == "SUPPLY_LIST") {
            item.source = "进货单";
          } else if (item.source == "DISTRIBUTION_FEE") {
            item.source = "配送费";
          } else if (item.source == "WMC_REWARD") {
            item.source = "工友圈帖子打赏募捐";
          } else if (item.source == "RETURN_ORDER") {
            item.source = "退货单退款";
          } else if (item.source == "MANUAL_AMOUNT") {
            item.source = "手动添加";
          } else if (item.source == "VOUCHER") {
            item.source = "抵用券支付";
          } else if (item.source == "RUSH_BUY_ORDER") {
            item.source = "抢购商品订单支付";
          } else if (item.source == "PRE_FILTER") {
            item.source = "前置过滤器安装";
          } else if (item.source == "PROMOTE") {
            item.source = "推广费";
          } else if (item.source == "PRODUCT_ORDER") {
            item.source = "产品订单";
          } else if (item.source == "SNAP_ORDER") {
            item.source = "抢购订单";
          } else if (item.source == "PURCHASE_ORDER") {
            item.source = "采购订单";
          } else if (item.source == "SELL_ORDER") {
            item.source = "销售订单";
          } else if (item.source == "GOODS_STOCK") {
            item.source = "商品入库";
          } else if (item.source == "PLEDGE") {
            item.source = "押金";
          } else {
            item.source = "error:" + item.source;
          }
          return item;
        });
        this.tableLoading = false;
        let s = formatterDateToUTC(new Date().getTime());
        let c = getCompany();
        printJS({
          printable: someJSONdata,
          header: `<div style='display:flex;flex-flow: row nowrap;width:100%; justify-content: space-between;'><div>打印时间：${s}</div><div style="margin-right:15px;">${c}</div></div>`,
          properties: [
            { field: "professionNumber", displayName: "业务编号" },
            { field: "source", displayName: "入账来源" },
            { field: "enterTime", displayName: "入账时间" },
            { field: "enterMoney", displayName: "入账金额(元)" },
            { field: "type", displayName: "资金类型" },
          ],
          gridHeaderStyle:
            "border: 1px solid  lightgray;white-space:nowrap;padding:0px 8px;text-align:center ",
          gridStyle:
            "border: 1px solid lightgray;white-space:nowrap;padding:8px 10px ;text-align:center;margin-bottom:50px;",
          type: "json",
        });
      });
    },
  },
};
</script>
    <style lang="scss">
#charts {
  display: flex;
  background: #fff;
  margin: 1px 10px;
  justify-content: space-around;
}
.as {
  position: relative;
  top: -1px;
  display: flex;
  justify-content: flex-end;
}
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
